import { render, staticRenderFns } from "./temperature-dialog.vue?vue&type=template&id=3b4e684a&"
import script from "./temperature-dialog.vue?vue&type=script&lang=js&"
export * from "./temperature-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports